<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <div class="user-clickable">
        <i class="fa fa-user-circle" style="color:#4F4F4F"/>
        <!-- <b-badge variant="danger" class="badge">{{ totalizadorCliente }}</b-badge> -->
      </div>
    </template>
    <template slot="dropdown">
      <b-dropdown-item v-on:click="opcoes()">
        <i class="fa fa-cog" /> Opções
      </b-dropdown-item>
      <b-dropdown-item v-on:click="sair()">
        <i class="fa fa-lock" /> Sair
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<style>
.user-clickable {
  height: auto !important;
  margin: 0px 30px !important;
  font-size: 40px;
}
.badge {
  font-size: 10px;
  margin-left: 10px !important;
}
.dropdown-item.active, .dropdown-item:active, .dropdown-item:active > i {
    color: #fff;
    text-decoration: none;
    background-color: #d82020 !important;
    font-weight: bold;
}
</style>


<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 42,
      atualizacoesCliente: 0,
      notificacoesCliente: 0,
      totalizadorCliente: 10,
      sair() {
        localStorage.clear();
        window.location.reload();
      },
      opcoes() {
        this.$router.push("/opcoes");
      }
    };
  }
};
</script>
